module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1114.444580d1.png";